import type { VoteState } from "@/lib/types";

export const STATE_LABEL: Record<VoteState, string> = {
  ready: "예정",
  open: "진행중",
  closed: "종료",
};

export const STATE_ORDER: Record<VoteState, number> = {
  open: 0,
  ready: 1,
  closed: 2,
};

export const STATE_BADGE: Record<VoteState, string> = {
  ready: "bg-secondary-100 text-secondary-900",
  open: "bg-accent-100 text-accent-900",
  closed: "bg-background-200 text-foreground-500",
};

// «투표» / «설문» 표기 — 서버가 준 type_txt 우선
export function typeLabel(vtype?: string, typeTxt?: string): string {
  if (typeTxt) return typeTxt;
  return vtype === "survey" ? "설문" : "투표";
}

// "YYYY-MM-DD HH:mm:ss" → "YYYY.MM.DD HH:mm"
export function formatDateTime(value?: string): string {
  if (!value) return "";
  const str = String(value).replace(" ", "T");
  const d = new Date(str);
  if (Number.isNaN(d.getTime())) return value;
  const y = d.getFullYear();
  const mo = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");
  return `${y}.${mo}.${day} ${hh}:${mm}`;
}

// 남은 초를 "HH:MM:SS" 로 표기
export function formatCountdown(totalSeconds: number): string {
  const s = Math.max(0, Math.floor(totalSeconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${pad(h)}:${pad(m)}:${pad(sec)}`;
}

export interface CountdownText {
  text: string;
  urgent: boolean;
}

// 카드용 남은 시간 표기
// 1일 이상 → "2일 03:15:22", 1시간 미만 → "15:22"(urgent 강조)
export function formatBannerCountdown(totalSeconds: number): CountdownText {
  const s = Math.max(0, Math.floor(totalSeconds));
  const days = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const pad = (n: number) => String(n).padStart(2, "0");
  const hms = `${pad(h)}:${pad(m)}:${pad(sec)}`;
  const urgent = s < 3600;
  if (days >= 1) return { text: `${days}일 ${hms}`, urgent };
  if (urgent) return { text: `${pad(m)}:${pad(sec)}`, urgent };
  return { text: hms, urgent };
}